import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const OVGStore = {
  namespaced: true,
  state: {
    cliente: null,
    equipo: null,
    boleta: null,
    // OVG09: la garantía única se separa en extensión de tiempo (paso 3, o null
    // si "No necesito extensión") + protecciones adicionales (paso 4, 0-2).
    fechaCompraEquipo: null,
    extension: null,
    protecciones: [],
    // OVG03.2 — Cupón de descuento (SILL-1523)
    cupon: null,        // { codigo, porcentaje_descuento } o null
    cuponLoading: false,
    cuponError: null,   // string de error o null
  },
  getters,
  mutations,
  actions,
}

export default OVGStore
